import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 获取商户入款订单统计
export const getDepositOrder = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/deposit-order',
    method: 'get',
    params
})

// 获取商户代付订单统计
export const getPayoutOrder = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/payout-order',
    method: 'get',
    params
})

// 获取商户结算订单统计
export const getSettlementOrder = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/settlement-order',
    method: 'get',
    params
})

// 导出商户入款订单统计
export const exportDepositOrder = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/deposit-order-export' + objToUrlParams(data),
    method: 'post'
})

// 导出商户出款订单统计
export const exportPayoutOrder = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/payout-order-export' + objToUrlParams(data),
    method: 'post'
})

// 导出商户结算订单统计
export const exportSettlementOrder = (data: any) => request({
    url: '/manage/merchant/' + data.merchant_no + '/settlement-order-export' + objToUrlParams(data),
    method: 'post'
})